import {Controller} from "stimulus"
import {klaviyoEvents} from "./mixins/klaviyoEvents";

/**
 * @description This class is used to push data to Google Tag Manager (GTM) dataLayer.
 * слуша за следните събития:
 * 'gtm-event' - слуша за събития от frontend-a и ги пушва в dataLayer
 * 'ajaxComplete' и 'customAjaxComplete' - проверява дали има данни в X-DataLayer-Events header и ги пушава в dataLayer ако има такива
 *  customAjaxComplete се fire-ва при успешно завършване на fetch API request
 *
 * App\Service\DataLayerService - може да се използва асинхронно(данните са в header-а) и синхронно(данните са в сесията)
 */

export default class extends Controller {
    impressionData;
    promotionData;

    connect() {
        if (!window.dataLayer) {
            return
        }
        klaviyoEvents(this);
        this.object = this.element.getAttribute('data-object');
        this.event = this.element.getAttribute("data-event");
        this.action = this.element.getAttribute("data-action");
        this.eventData = this.element.getAttribute("data-data");
        this.userId = Number(this.element.getAttribute("data-user-id"));
        this.uniqueEventId = this.element.getAttribute("data-unique-event-id") ?? null;

        this.impressionData = [];
        this.promotionData = [];

        if (this.event && this.action) {
            this.prepareEvent();
        } else {
            this.prepareSimpleEvent();
        }

        this.eventsTriggeredByBackEndService();
    }

    eventsTriggeredByBackEndService() {
        const _self = this;

        // добавяме dataLayerEvents от сесията генерирани от DataLayerService
        let dataLayerEvents = this.element.getAttribute("data-data-layer-events");
        dataLayerEvents = JSON.parse(dataLayerEvents);

        if (dataLayerEvents) {
            for (const eventData of dataLayerEvents) {
                this.pushData(eventData);
            }
        }

        // AJAX events generated by DataLayerService
        $(document).on("ajaxComplete", function (event, xhr) {
            const dataLayerHeader = xhr.getResponseHeader('X-DataLayer-Events');
            _self.pushAjaxData(dataLayerHeader);
        });

        // Fetch API-то не тригерира ajaxComplete за това правим custom събитие
        document.addEventListener('customAjaxComplete', (e) => {
            const dataLayerHeader = e.detail.xhr.getResponseHeader('X-DataLayer-Events');
            _self.pushAjaxData(dataLayerHeader);
        });
    }

    pushAjaxData(dataLayerHeader) {
        if (dataLayerHeader) {
            try {
                const eventsData = JSON.parse(dataLayerHeader);
                eventsData.forEach(eventData => {
                    if (eventData) {
                        this.pushData(eventData)
                    }
                });
            } catch (e) {
                console.error('Error parsing DataLayer events:', e);
            }
        }
    }

    prepareEvent() {
        if (this.event === 'view_item') {
            this.viewItem(); //new
        } else if (this.event === 'view_cart') {
            this.viewCart();//new
        } else if (this.event === 'begin_checkout' && this.action === 'begin_checkout_product') {
            this.beginCheckoutProduct(); //new
        } else if (this.event === 'purchase') {
            this.purchaseProducts();//new
        } else if (this.event === 'eec.lead') {
            this.eecLead();
        }
    }

    getCategoryNamesGTM(categoryNamesGTM) {
        let categories = {}
        if (typeof categoryNamesGTM === 'object') {
            for (const index in categoryNamesGTM) {
                let key = 'category'
                if (index > 0) {
                    key += Number(index) + 1;
                }
                categories[key] = categoryNamesGTM[index];
            }
        }
        return categories;
    }

    onGtmEvent(data) {
        this.event = data.event;
        this.action = data.action;
        this.eventData = data.eventData;
        this.uniqueEventId = data.unique_event_id;
        this.cart = data.cart;

        if (this.event === 'add_to_cart') {
            this.addToCart();
        } else if (this.event === 'remove_from_cart') {
            this.removeFromCart();
        } else if (this.event === 'eec.checkout') {
            // this.eecCheckout();
        } else if (this.event === 'add_shipping_info') {
            this.addShippingInfo();
        } else if (this.event === 'select_item') {
            this.selectItem();
        } else if (this.event === 'select_promotion' || this.event === 'view_promotion') {
            this.promotion();
        } else if (this.event === 'view_item_list') {
            this.pushData(JSON.parse(JSON.stringify(data)));
        } else if (this.event === 'add_payment_info') {
            this.addPaymentInfo();
        }
    }

    buildProductDataLayer(data, event, quantity = 1) {
        const url = new URL(window.location.href);
        const origin = url.origin + '/';
        const categories = this.getCategoryNamesGTM(data.categoryNamesGTM)
        const listData = this.getListData(data.id);

        return {
            event: event,
            ...(this.userId && {user_id: this.userId}),
            ecommerce: {
                currency: 'EUR', // валута
                value: parseFloat(data.sale_price) * quantity, //стойност на продукта, подават се динамични стойности
                items: [
                    {
                        item_id: data.id, //ид на селектирания продукт, подават се динамични стойности
                        item_name: data.name, //име на  селектирания продукт,подават се динамични стойности
                        item_brand: data.brand, //категория на продукта, подават се динамични стойности
                        ...listData,
                        discount: (parseFloat(data.price) - data.sale_price), //стойност на отстъпка, подават се динамични стойности
                        price: parseFloat(data.sale_price), //стойност на продукта, подават се динамични стойности
                        quantity: quantity, //количество
                        url: origin + data.path,
                        ...categories,
                        categories: data.categoryNamesGTM,
                        image_url: origin + data.image_path,
                        sku: data.sku,
                    }
                ]
            }
        }
    }

    buildCartDataLayer(data, event) {
        let items = [];
        const url = new URL(window.location.href);
        const origin = url.origin + '/';

        data.rows.forEach(cartRow => {
            let categories = this.getCategoryNamesGTM(cartRow.categoryNamesGTM);
            const listData = this.getListData(cartRow.productId);

            items.push(
                {
                    item_id: cartRow.productId, //ид на селектирания продукт, подават се динамични стойности
                    item_name: cartRow.name, //име на  селектирания продукт,подават се динамични стойности
                    ...listData,
                    discount: (cartRow.originalPrice - cartRow.price), //стойност на отстъпка, подават се динамични стойности
                    price: parseFloat(cartRow.price), //стойност на продукта, подават се динамични стойности
                    quantity: cartRow.quantity, //количество
                    affiliation: 'benu-online-store',
                    coupon: cartRow.promocode,
                    item_brand: cartRow.brandName,
                    url: origin + cartRow.path,
                    ...categories
                }
            );
        });

        return {
            event: event,
            ...(this.userId && {user_id: this.userId}),
            ...(this.promocode && {coupon: data.promocode?.code}),
            ecommerce: {
                currency: 'EUR',
                value: parseFloat(data.totalPriceAfterDiscount), //стойност на продукта, подават се динамични стойности
                items: items
            }
        }
    }

    purchaseProducts() {
        let layer = JSON.parse(this.eventData);
        layer["event"] = this.event;
        layer.ecommerce?.items.forEach((item, index) => {
            const listData = this.getListData(item.item_id);
            layer.ecommerce.items[index] = Object.assign({}, item, listData);
        })

        layer.user_email = layer.user_email.toLowerCase() || "";
        layer.user_firstname = layer.user_firstname.toLowerCase() || "";
        layer.user_lastname = layer.user_lastname.toLowerCase() || "";
        layer.user_phone = layer.user_phone.toLowerCase() || "";
        layer.user_address = layer.user_address.toLowerCase() || "";
        layer.user_city = layer.user_city.toLowerCase() || "";

        this.pushData(layer);
    }

    beginCheckoutProduct() {
        let data = JSON.parse(this.eventData);
        let layer = this.buildCartDataLayer(data, this.event);

        this.pushData(layer);
        const klaviyoData = this.beginCheckoutKlaviyo();
        this.pushData(klaviyoData);
    }

    viewItem() {
        let data = JSON.parse(this.eventData);
        let layer = this.buildProductDataLayer(data, this.event);

        this.pushData(layer);
    }

    viewCart() {
        let data = JSON.parse(this.eventData);
        let layer = this.buildCartDataLayer(data, this.event);

        this.pushData(layer);
    }

    addToWishlist(data) {
        let layer = this.buildProductDataLayer(JSON.parse(data), 'add_to_wishlist');

        this.pushData(layer);
    }

    addToCart() {
        const layer = this.buildProductDataLayer(this.eventData, this.event, this.eventData.quantity);
        const listData = this.getListData(this.eventData.id);

        this.pushData(layer);

        const klaviyoData = this.addToCartKlaviyo();
        this.pushData(klaviyoData);

        this.trackSearchConversionIfApplicable(listData?.item_list_id, 'add_to_cart', this.eventData.id);
    }

    removeFromCart() {
        let layer = this.buildProductDataLayer(this.eventData, this.event, this.eventData.quantity);

        this.pushData(layer);
    }


    //ENDNEW

    prepareSimpleEvent() {

        if (this.eventData) {
            let layer = {
                [this.object]: JSON.parse(this.eventData)
            }
            // this.pushData(layer);
        }
    }

    initialize() {

        if (!window.dataLayer) {
            return;
        }
        this.dataLayer = window.dataLayer;
        this.isMain = this.element.getAttribute('data-main');

        if (this.isMain) {
            EventManager.listen('gtm-event', payload => {
                this.onGtmEvent(payload);
            });

            //NEW
            EventManager.listen('favorite-added', payload => {
                this.addToWishlist(payload);
            });

        }
        EventManager.listen('add-to-cart-gtm-context', payload => {
            this.updateListNameId(payload.productId, payload.context)
        });
        EventManager.listen('favorite-added-gtm-context', payload => {
            this.updateListNameId(payload.productId, payload.context)
        });

        EventManager.fire('load-stimulus', null);
    }

    onLoadEventCheckout(data) {
        let productsData = [];
        productsData[0] = {
            'name': data.name,
            'id': data.id,
        };

        let layer = {
            event: 'ecc.event-checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 1
                    },
                    products: productsData,
                    checkout_type: 'Events'
                }
            }
        }

        this.pushData(layer);
    }

    initSimpleStep(step, checkoutType) {
        let layer = {
            event: 'ecc.event-checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: step
                    },
                    checkout_type: checkoutType
                }
            }
        }

        this.pushData(layer);
    }

    onImpressionEvent(data) {
        this.impressionData.push(data);
    }

    onPageViewEvent(data) {
        this.sendPageView(data);
    }

    sendImpressions() {
        if (this.impressionData.length !== 0) {
            let layer = {
                event: 'eec.impressionView',
                ecommerce: {
                    impressions: this.impressionData
                }
            }

            this.pushData(layer);
            this.impressionData = [];
        }
    }

    sendPageView(uniqueEventId) {
        if (uniqueEventId.length !== 0) {
            let layer = {
                event: 'eec.pageView',
                page_view_unique_event_id: uniqueEventId,
                ecommerce: {}
            }

            this.pushData(layer);
            this.pageViewData = [];
        }
    }

    eecLead() {
        let layer = {
            lead_unique_event_id: this.uniqueEventId,
            event: this.event,
        }

        this.pushData(layer);
    }

    addPaymentInfo() {
        let layer = this.buildCartDataLayer(this.cart, this.event);
        let cloneLayer = {...layer}
        cloneLayer.ecommerce.payment_type = this.eventData?.method;

        this.pushData(cloneLayer);
    }

    addShippingInfo() {
        let layer = this.buildCartDataLayer(this.cart, this.event);
        let cloneLayer = {...layer}
        cloneLayer.ecommerce.shipping_tier = this.eventData?.slug;

        this.pushData(cloneLayer);
    }

    selectItem() {
        let categories = this.getCategoryNamesGTM(this.eventData.product.categoryNamesGTM)
        const layer = {
            event: "select_item",
            ...(this.userId && {user_id: this.userId}),
            ecommerce: {
                items: [
                    {
                        item_id: this.eventData.product.id,
                        item_name: this.eventData.product.name,
                        item_list_id: this.eventData.list,
                        item_list_name: this.eventData.list,
                        price: this.eventData.product.price,
                        index: this.eventData.product.position,
                        item_variant: this.eventData.product.variant,
                        ...categories
                    }
                ]
            }
        };

        this.updateListNameId(this.eventData.product.id, this.eventData.list);

        this.pushData(layer);
        this.trackSearchConversionIfApplicable(this.eventData.list, 'product_click', this.eventData.product.id);
    }

    promotion() {
        const layer = {
            event: this.event,
            ...(this.userId && {user_id: this.userId}),
            ecommerce: {
                promotion_id: this.eventData.id,
                promotion_name: this.eventData.name,
                creative_name: this.eventData.creativeName,
                creative_slot: this.eventData.creativeSlot
            }
        };
        this.pushData(layer);
    }

    getListData(productId) {
        const isCartWidget = document.querySelector('body.cart-show') !== null;
        const isProductPage = document.querySelector('main.page.product') !== null;
        const listNameId = sessionStorage.getItem(`item_list_id_${productId}`);
        const normalizedListNameId = listNameId ? listNameId.toLocaleLowerCase() : null;

        if (isProductPage && normalizedListNameId) {
            // Потребителят е влязъл в продуктова страница чрез категория или друг продуктов списък
            return {item_list_id: normalizedListNameId, item_list_name: normalizedListNameId};
        }
        if (normalizedListNameId) {
            // Потребителят е извършил действие от списък с продукти (категория, carousel-и, и т.н.)
            return {item_list_id: normalizedListNameId, item_list_name: normalizedListNameId};
        }

        if (isCartWidget) {
            sessionStorage.setItem(`item_list_id_${productId}`, 'cart-widget');
            return {item_list_id: 'cart-widget', item_list_name: 'cart-widget'};
        }

        if (isProductPage) {
            // Продуктът е достъпен от външен линк директно към продуктовата страница
            sessionStorage.setItem(`item_list_id_${productId}`, 'product-page');
            return {item_list_id: 'product-page', item_list_name: 'product-page'};
        }

        // Няма информация за произхода
        return {};
    }

    updateListNameId(productId, context) {
        if (context) {
            sessionStorage.setItem(`item_list_id_${productId}`, context);
        }
    }

    trackSearchConversionIfApplicable(itemListId, conversionType, productId) {
        if (!itemListId || typeof itemListId !== 'string') return;
        const normalized = itemListId.toLowerCase().trim();
        if (!normalized.startsWith('search-')) return;

        const searchTerm = normalized.substring(7);
        if (!searchTerm) return;

        const url = this.element.getAttribute('data-search-conversion-url');
        if (!url) return;

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
                search_term: searchTerm,
                conversion_type: conversionType,
                product_id: productId
            })
        }).catch(() => {});
    }

    pushData(data) {
        this.prepareKlavyoIdentify(data);
        delete data.klaviyoIdentify;

        this.dataLayer.push({ecommerce: null});
        this.dataLayer.push(data);
    }

    prepareKlavyoIdentify(data) {

        let storedData = sessionStorage.getItem('klaviyoIdentify');
        if (storedData) {
            storedData = JSON.parse(storedData);
        }

        const klaviyoIdentifyData = data.klaviyoIdentify || storedData;

        if (!klaviyoIdentifyData) {
            return;
        }

        if (window.klaviyo) {
            this.identify(klaviyoIdentifyData).then(
                () => sessionStorage.removeItem('klaviyoIdentify')
            );
        } else {
            sessionStorage.setItem('klaviyoIdentify', JSON.stringify(klaviyoIdentifyData));
        }
    }
}
